
var text_en = {
    'Welcome': 'Welcome',
    'Loading': 'Loading',
    'Click to start': 'Click to start',
    'Navigation': 'Navigation',
    'See products': 'See products',
    'Back': 'Back',
    'View map': 'View map',
    'Close map': 'Close map',
    'help_nav' : `Hold click / touch to <b>rotate</b>
                    <br />
                    <b>Click on an area</b> to navigate`,
    'help_product' : `Hold click / touch to <b>rotate</b>
                <br />
                Scroll / pinch to <b>zoom</b>
                <br />
                <b>Click on an area</b> to navigate`,
    'help_map' : `Hold click / touch to <b>move</b>
                <br />
                Scroll / pinch to <b>zoom</b>
                <br />
                <b>Click on an area</b> to navigate`
}

var text_fr = {
    'Welcome': 'Bienvenue',
    'Loading': 'Chargement',
    'Click to start': 'Cliquez pour démarrer',
    'Navigation': 'Navigation',
    'See products': 'Voir les produits',
    'Back': 'Retour',
    'View map': 'Voir la carte',
    'Close map': 'Fermer',
    'help_nav' : `Clic long / touch: <b>tourner</b>
                    <br />
                    Cliquez sur une zone pour <b>avancer</b>`,
    'help_product' : `Clic long / touch: <b>tourner</b>
                <br />
                Scroll / pincement: <b>zoom</b>
                <br />
                Cliquez sur une zone pour <b>avancer</b>`,
    'help_map' : `Clic long / touch: <b>déplacer</b>
                <br />
                Scroll / pincement: <b>zoom</b>
                <br />
                <b>Cliquez sur une zone</b> pour naviguer`
}

/**
 * Handles language
 */
export default class Lang {
    constructor(app) {

        this.App = app;

        //this.lang = navigator.language
        this.lang = 'en-EN' // force english for now
        

        this.texts = {
            'en-EN': text_en,
            'en-US': text_en,
            'de-DE': text_en,
            'es-ES': text_en,
            'it-IT': text_en,
            'nl-NL': text_en,
            'pt-PT': text_en,
            'ru-RU': text_en,
            'sv-SE': text_en,
            'tr-TR': text_en,
            'zh-CN': text_en,
            'fr-FR': text_fr
        }

        

    }


    get(key) {
        if(key in this.texts[this.lang])
            return this.texts[this.lang][key]
        else
            return key
    }

    

}